import { Component, OnInit, ViewChild } from '@angular/core';
import { UsuarioResultadoBusquedaModel } from 'src/app/models/usuario/UsuarioResultadoBusquedaModel';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { RegistrarUsuarioDialogComponent } from '../registrar-usuario-dialog/registrar-usuario-dialog.component';
import { SeguridadUsuarioService } from 'src/app/services/seguridad/seguridad-usuario.service';
import { SedeService } from 'src/app/services/sede/sede.service';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { UsuarioRegistrarModel } from 'src/app/models/seguridad/UsuarioRegistrarModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { FilterUsuarioModel } from 'src/app/models/seguridad/FilterUsuarioModel';
import { MatPaginator } from '@angular/material/paginator';
import { eTypeResult, ParametrosMaestro, TipoUsuario } from 'src/app/models/common/enumModel';
import * as fileSaver from 'file-saver';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { CompaniaService } from 'src/app/services/compania/compania.service';
import { IFilterCompaniaModel } from 'src/app/models/interfaces/compania/IFilterCompaniaModel';
import { FilterCompaniaModel } from 'src/app/models/compania/FilterCompaniaModel';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-lista',
  templateUrl: './lista.component.html',
  styleUrls: ['./lista.component.css']
})
export class ListaComponent implements OnInit {
  displayedColumns: string[] = ['nombre', 'tipo', 'correo', 'estado', 'acciones'];
  listaUsuarios: UsuarioResultadoBusquedaModel[] = new Array<UsuarioResultadoBusquedaModel>();
  listaSedes: SedeModel[] = new Array<SedeModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  paramsEstados: ParametroModel[] = new Array<ParametroModel>();
  resultsLength = 0;
  currentPage = 0;

  @ViewChild('paginator') paginator!: MatPaginator;

  filter: FilterUsuarioModel = new FilterUsuarioModel();
  // animal: string;
  // name: string;

  constructor(
    private sedeService: SedeService,
    private companiaService: CompaniaService,
    public dialog: MatDialog,
    private service: SeguridadUsuarioService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private parametroService: ParametroService) {
    // this.animal = '';
    // this.name = '';
  }

  ngOnInit(): void {
    this.filter.idTipoUsuario = TipoUsuario.Empleado;
    this.filter.pageSize = 30;
    this.service.getList(this.filter).subscribe((data: SearchResultModel<UsuarioResultadoBusquedaModel[]>) => {
      this.listaUsuarios = data.items;
      this.resultsLength = data.total;
    });

    this.parametroService
      .getDetalles(ParametrosMaestro.EstadosUsuarios)
      .subscribe((data) => {
        this.paramsEstados = data.items;
      });

    const filterSede: IFilterSedeModel = new FilterSedeModel();
    this.sedeService.getListFiltered(filterSede).subscribe((data: SearchResultModel<SedeModel[]>) => {
      this.listaSedes = data.items;
    });

    const filterCompania: IFilterCompaniaModel = new FilterCompaniaModel();
    this.companiaService
      .getAllList(filterCompania)
      .subscribe((data: CompaniaModel[]) => {
        this.listaCompanias = data;
      });
  }

  openDialog(usuario?: UsuarioRegistrarModel): void {
    if (!usuario)
      usuario = new UsuarioRegistrarModel();

    const dialogRef = this.dialog.open(RegistrarUsuarioDialogComponent, {
      width: '1000px',
      // data: { name: this.name, animal: this.animal}
      data: usuario
    });

    dialogRef.afterClosed().subscribe(result => {
      this.service.getList(this.filter).subscribe((data: SearchResultModel<UsuarioResultadoBusquedaModel[]>) => {
        this.listaUsuarios = data.items;
        this.resultsLength = data.total;
        this.search();
      });
      // this.animal = result;
      // console.log(result);
      // this.service.submit(result).subscribe(p => {
      //   console.log(p);
      // });
    });
  }

  eliminar(id: number): void {
    this.service.delete(id).subscribe(p => {

    });
  }

  deshabilitar(usuario: UsuarioResultadoBusquedaModel): void {
    this.confirmDialogService.open(`¿Está seguro de deshabilitar el usuario ${usuario.correo}`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.service.disable(usuario.idUsuario).subscribe((result: ActionResultModel) => {
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
          else {
            this.alertDialogService.open("El usuario ha sido deshabilitado correctamente");
          }
          this.search();
        });
      }
    });

    
  }

  getPaginatorData(event: any) {
    this.filter.page = event.pageIndex + 1;
    this.filter.pageSize = event.pageSize;
    this.service
      .getList(this.filter)
      .subscribe((data: SearchResultModel<UsuarioResultadoBusquedaModel[]>) => {
        this.listaUsuarios = data.items;
        this.resultsLength = data.total;
      });
  }

  search() {
    this.filter.page = 1;
    this.filter.pageSize = 30;
    this.service
      .getList(this.filter)
      .subscribe((data: SearchResultModel<UsuarioResultadoBusquedaModel[]>) => {
        this.listaUsuarios = data.items;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  export() {
    //this.paginator.pageIndex = 0;
    this.filter.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.service.getListToExport(this.filter).subscribe(
      (data) => {
        // console.log(data.headers.get('content-disposition'));
        // console.log(data.headers);
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        const url = window.URL.createObjectURL(blob);

        //window.open(url);
        //window.location.href = response.url;
        fileSaver.saveAs(blob, `usuarios-${Date.now()}.xlsx`);

        //  this.createImageFromBlob(data);
        //  this.isImageLoading = false;
      },
      (error) => {
        //  this.isImageLoading = false;
        //  console.log(error);
      }
    );
  }
}
